import React from 'react';
import useToolStore from '../../store/useToolStore';
import { DEVICE_SPECS, DEFAULT_DEVICE } from '../../utils/deviceSpecs';

const DeviceSelector = () => {
  const selectedDevice = useToolStore((state) => state.selectedDevice || DEFAULT_DEVICE);
  const setSelectedDevice = useToolStore((state) => state.setSelectedDevice);

  const deviceGroups = [
    {
      label: 'iPhone 15 Series',
      devices: ['iphone-15', 'iphone-15-pro', 'iphone-15-plus', 'iphone-15-pro-max'],
    },
    {
      label: 'iPhone 16 Series',
      devices: ['iphone-16', 'iphone-16-pro', 'iphone-16-plus', 'iphone-16-pro-max'],
    },
    {
      label: 'iPhone 17 Series',
      devices: ['iphone-17', 'iphone-17-pro', 'iphone-17-plus', 'iphone-17-pro-max'],
    },
  ];

  return (
    <div className="bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4 transition-colors duration-200">
      <label className="block text-sm font-medium text-gray-900 dark:text-gray-300 mb-2">
        Device Preview
      </label>
      <select
        value={selectedDevice}
        onChange={(e) => setSelectedDevice(e.target.value)}
        className="w-full bg-white dark:bg-gray-700 text-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-colors"
      >
        {deviceGroups.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.devices.map((deviceId) => (
              <option key={deviceId} value={deviceId}>
                {DEVICE_SPECS[deviceId].name}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
};

export default DeviceSelector;
